import { Tag } from '../types';
import request from './request';

export const getTagsApi = async (): Promise<Tag[]> => {
  const response = await request.get('/api/tags');
  // Check if response.data is the array directly or if it's nested
  const data = Array.isArray(response.data) ? response.data : response.data.data || [];
  
  return data.map((t: { id: number; name: string; color: string }) => ({
    id: String(t.id),
    name: t.name,
    color: t.color,
  }));
};
